import { makeStyles } from "components/providers/makeStyles";

import { Checkbox } from "../forms/fields/Checkbox";
import { Typography } from "@mui/material";
import { T } from "../../util/t";

const useStyles = makeStyles(theme => ({
    listItemLabel: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1, 2, 1, 0),
        minHeight: theme.spacing(8),
        borderBottom: `1px solid ${theme.palette.border.light}`,
        cursor: "default",
        "& > div > div": {
            marginTop: theme.spacing(0.5),
            color: theme.palette.text.link,
            fontSize: theme.typography.pxToRem(16)
        }
    },
    alternate: {
        "&&": {
            color: theme.palette.text.light,
        }
    }
}));

export const AddEntryDialogContentItem = ({ item, isTeams, selected, selectItem, registered, alternates }) => {
    const classes = useStyles();
    const isRegistered = registered.some(r => r.athlete.id === parseInt(item.id));
    const isAlternate = alternates.some(a => a.athlete.id === parseInt(item.id));

    return (
        <label className={classes.listItemLabel}>
            <div>
                <Typography variant="h7">{item.name}</Typography>
                {item.isNew && <div><T>{isTeams ? "Create new team" : "Create new athlete"}</T></div>}
                {isAlternate && <div className={classes.alternate}><T>Cancelled</T></div>}
            </div>
            <Checkbox
                input={{
                    disabled: isRegistered,
                    value: isRegistered || !!selected[item.id],
                    onChange: e => selectItem(item, e.target.checked),
                    onKeyDown: e => e.key === "Enter" && selectItem(item, !e.target.checked)
                }}
            />
        </label>
    );
};
